import { Component, computed, effect, input, signal } from '@angular/core';
import {
  PatientBehaviorAntecedentModel,
  PatientBehaviorConsequenceModel,
} from '../../../core/api/models';
import {
  StaffApiService,
  SupervisorApiService,
} from '../../../core/api/services';
import { AlertService } from '../../../shared/services/alert.service';
import { SupervisorHelperService } from '../../supervisor.helper.service';
import { Utils } from '../../../core/utils';
import { SelectItemGroup } from 'primeng/api';
import { Router } from '@angular/router';
@Component({
  selector: 'app-consequences',
  templateUrl: './consequences.component.html',
  standalone: false,
})
export class ConsequencesComponent {
  patientID = input.required<number>();

  consequences = signal<PatientBehaviorConsequenceModel[]>([]);

  loadingConsequences = signal<boolean>(false);
  showAddConsequence = this.supervisorHelperService.showAddConsequence;

  searchKeyword = signal<string | null>(null);
  includeDeleted = signal<boolean>(false);

  filteredConsequences = computed(() => {
    let filteredConsequences = this.consequences();
    // use keyword from search bar for the first filter
    if (this.searchKeyword() != null && this.searchKeyword() != '') {
      filteredConsequences = filteredConsequences.filter((consequence) =>
        consequence.PatientBehaviorConsequence?.toLowerCase().includes(
          this.searchKeyword()!.toLowerCase()
        )
      );
    }
    if (!this.includeDeleted()) {
      filteredConsequences = filteredConsequences.filter(
        (consequence) => !consequence.IsDeleted
      );
    }
    return filteredConsequences;
  });

  constructor(
    private staffApiService: StaffApiService,
    private supervisorApiService: SupervisorApiService,
    private alertService: AlertService,
    protected supervisorHelperService: SupervisorHelperService,
    private router: Router
  ) {
    effect(
      () => {
        console.log(
          'update signal triggered: ',
          this.supervisorHelperService.updateSignal()
        );
        this.loadData();
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    console.log('ConsequencesComponent ngOnInit');
    if (this.patientID()) {
      this.loadData();
    } else {
      this.router.navigate(['/select-patient']);
    }
  }

  loadData() {
    this.loadingConsequences.set(true);
    this.staffApiService
      .GetPatientBehaviorConsequences({ patientID: Number(this.patientID()) })
      .subscribe(
        (consequences) => {
          this.loadingConsequences.set(false);
          this.consequences.set(consequences);
        },
        (err) => {
          this.loadingConsequences.set(false);
          this.alertService.error(Utils.getErrorMessageFromErrorResponse(err));
        }
      );
  }

  addConsequenceButtonClicked() {
    console.log('addConsequenceButtonClicked');
    this.supervisorHelperService.addConsequenceButtonClicked(null);
  }

  onCloseAddConsequence(withChanges: boolean = false) {
    this.supervisorHelperService.onCloseAddConsequence(withChanges);
  }

  getFromBIPButtonClicked() {
    console.log('getFromBIPButtonClicked');
    this.supervisorApiService
      .ImportConsequencesFromBIP({ patientID: Number(this.patientID()) })
      .subscribe(
        (response) => {
          console.log('ImportConsequencesFromBIP response: ', response);
          this.loadData();
        },
        (err) => {
          this.alertService.error(Utils.getErrorMessageFromErrorResponse(err));
        }
      );
  }

  clearSearch() {
    this.searchKeyword.set(null);
    this.includeDeleted.set(false);
  }

  toggleIncludeDeleted() {
    this.includeDeleted.set(!this.includeDeleted());
  }
}
